import { logUtil } from 'packages/src'

/**
 * Updates consent for all analytics tools:
 * - Microsoft Clarity Consent API
 * - Google Consent Mode v2
 * - Meta Pixel
 */
export const updateAnalyticsConsentUtil = (consent) => {
  const logger = logUtil('consent:updateAnalytics')
  const { analytics, marketing, preferences } = consent

  logger.info('Updating consent:', { analytics, marketing, preferences })

  // Update Microsoft Clarity Consent API
  if (typeof window !== 'undefined' && window.clarity) {
    try {
      logger.debug('Clarity: Setting consent to', analytics)
      window.clarity('consent', analytics)
      logger.info('Clarity: Consent updated successfully')
    } catch (error) {
      logger.error('Clarity: Failed to update consent:', error)
    }
  } else {
    logger.debug('Clarity: Not available (window.clarity not found)')
  }

  // Update Google Consent Mode v2
  if (typeof window !== 'undefined' && window.gtag) {
    try {
      const consentData = {
        analytics_storage: analytics ? 'granted' : 'denied',
        ad_storage: marketing ? 'granted' : 'denied',
        ad_user_data: marketing ? 'granted' : 'denied',
        ad_personalization: marketing ? 'granted' : 'denied',
        functionality_storage: preferences ? 'granted' : 'denied',
        personalization_storage: preferences ? 'granted' : 'denied'
      }
      logger.debug('Google: Updating consent mode:', consentData)
      window.gtag('consent', 'update', consentData)
      logger.info('Google: Consent updated successfully')
    } catch (error) {
      logger.error('Google: Failed to update consent:', error)
    }
  } else {
    logger.debug('Google: Not available (window.gtag not found)')
  }

  // Update Meta Pixel consent
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      const action = marketing ? 'grant' : 'revoke'
      logger.debug('Meta Pixel: Setting consent to', action)
      window.fbq('consent', action)
      logger.info('Meta Pixel: Consent updated successfully')
    } catch (error) {
      logger.error('Meta Pixel: Failed to update consent:', error)
    }
  } else {
    logger.debug('Meta Pixel: Not available (window.fbq not found)')
  }

  logger.info('All analytics tools updated')
}
